import { createContext, useState, useEffect } from 'react'


export const PropertiesContext = createContext({})

export function PropertiesProvider({children, ...rest}) {
  const[propertiesList, setPropertiesList] = useState(rest.properties)
  const[numberProperties, setNumberProperties] = useState(rest.numberProperties)
  
  const page = rest.pagination
  const cities = rest.cities
  const ufs = rest.ufs
  const phases = rest.phases
  const citiesAll = rest.citiesUfs

  useEffect(() => {
    setPropertiesList(rest.properties)
    setNumberProperties(rest.numberProperties)
  }, [rest.properties, page])

  return (
    <PropertiesContext.Provider 
      value={{
        propertiesList,
        numberProperties,
        cities,
        ufs,
        phases,
        page,
        citiesAll
      }}
    >
      {children}
    </PropertiesContext.Provider>
  )
}
